<template>
    <sa-page-layout :btnBackVisible="false" :btnNewVisible="false" :btnEditVisible="false" :pathResource="pathResource" :showModalLoading="showModalLoading">
        <template #toolbar>
            <b-button variant="primary btn-toolbar sa-margin-right float-sm-right" size="sm" @click="onScaricaCsv"> <font-awesome-icon icon="file-csv" />Download Excel</b-button>
        </template>
        <template slot="table-body">
            <rsa-adi-protocolli-riepologo-list-component ref="cmpRsaAdiProtocolliRiepilogoList"></rsa-adi-protocolli-riepologo-list-component>
        </template>
    </sa-page-layout>
</template>

<script>
import SaPageLayout from "../../../../template/sa/components/layout/contents/SaPageLayout.vue";
import RsaAdiProtocolliRiepologoListComponent from "../components/RsaAdiProtocolliRiepologoListComponent.vue";

export default {
    components: { SaPageLayout, RsaAdiProtocolliRiepologoListComponent },
    data() {
        return {
            pathResource: "",
            showModalLoading: false,
        };
    },
    mounted() {
        let me = this;
        me.init();
    },
    methods: {
        init() {
            let me = this;
            me.$refs.cmpRsaAdiProtocolliRiepilogoList.loadData();
        },
        onScaricaCsv() {
            let me = this;
            me.$refs.cmpRsaAdiProtocolliRiepilogoList.scaricaCsv();
        },
    },
};
</script>

<style></style>
